import { render, staticRenderFns } from "./CpyCategoryAdd.vue?vue&type=template&id=4c89a06f&scoped=true"
import script from "./CpyCategoryAdd.vue?vue&type=script&lang=js"
export * from "./CpyCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./CpyCategoryAdd.vue?vue&type=style&index=0&id=4c89a06f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c89a06f",
  null
  
)

export default component.exports